import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppTooltipModule } from '../tooltip/tooltip.module';
import { UserAvatarModule } from '../user-avatar/user-avatar.module';
import { ScrollModule } from '../scroll/scroll.module';
import { PipesModule } from '../pipes/pipes.module';
import { CommentsComponent } from './comments.component';
import { NoCommentsComponent } from './no-comments/no-comments.component';
import { CommentsService } from './comments.service';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppTooltipModule,
        UserAvatarModule,
        PipesModule,
        ScrollModule,
    ],
    declarations: [
        CommentsComponent,
        NoCommentsComponent,
    ],
    exports: [
        CommentsComponent,
        NoCommentsComponent,
    ],
    providers: [CommentsService]
})
export class CommentsModule {}
